import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Col from "react-bootstrap/Col";

class ShowTimeslot extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { timeslot } = this.props;
    return (
      <Form>
        <Form.Row>
          <Form.Group as={Col} controlId="formGridDate">
            <Form.Label>Date</Form.Label>
            <Form.Control readOnly value={timeslot.date} name="date" />
          </Form.Group>
          <Form.Group as={Col} controlId="formGridWindow">
            <Form.Label>Delivery Window</Form.Label>
            <Form.Control
              readOnly
              value={timeslot.delivery_window}
              name="delivery_window"
            />
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group as={Col}>
            <Form.Label>Available</Form.Label>
            <Form.Check
              readOnly
              checked={timeslot.available}
              name="available"
            />
          </Form.Group>
          <Form.Group as={Col}>
            <Form.Label>Out of zone eligible</Form.Label>
            <Form.Check
              readOnly
              checked={timeslot.out_of_zone_eligible}
              name="out_of_zone_eligible"
            />
          </Form.Group>
          <Form.Group as={Col} controlId="formGridNumberDrivers">
            <Form.Label>Number of drivers</Form.Label>
            <Form.Control
              readOnly
              value={timeslot.number_of_drivers}
              name="number_of_drivers"
            />
          </Form.Group>
        </Form.Row>
        <Form.Row>
          {timeslot.anchors && (
            <Col>
              <Form.Group as={Col} controlId={"formGridAnchors"}>
                <Form.Label>Anchors</Form.Label>
                <Form.Control
                  readOnly
                  value={timeslot.anchors}
                  name="anchors"
                />
              </Form.Group>
            </Col>
          )}

          <Col>
            {/* {timeslot.deliveries_per_hour && ( */}
            <Form.Row>
              <Form.Group controlid={"formGridDelivPerhour"}>
                <Form.Label>Deliveries Per Hour</Form.Label>
                <Form.Control
                  readOnly
                  value={
                    timeslot.deliveries_per_hour
                      ? timeslot.deliveries_per_hour
                      : ""
                  }
                />
              </Form.Group>
            </Form.Row>
            {/* )} */}
          </Col>
        </Form.Row>
        <Form.Row>
          {timeslot.destinations && (
            <Col>
              {timeslot.destinations.map((slot, i) => (
                <Form.Group
                  as={Col}
                  key={i}
                  controlId={`formGridDestinations${i}`}
                >
                  <Form.Label>Destinations</Form.Label>
                  <Form.Control
                    readOnly
                    value={timeslot.destinations[i]}
                    name="destinations"
                  />
                </Form.Group>
              ))}
            </Col>
          )}

          <Col>
            {timeslot.delivery_ids && (
              <Form.Row>
                {timeslot.delivery_ids.map((slot, i) => (
                  <Form.Group key={i}>
                    <Form.Label>Deliveries</Form.Label>
                    <InputGroup>
                      {timeslot.delivery_ids[i].map(
                        (id) =>
                          id != null && (
                            <Link key={id} to={`/deliveries/${id}`}>
                              <Form.Control
                                controlid={id}
                                readOnly
                                value={id}
                              />
                            </Link>
                          )
                      )}
                    </InputGroup>
                  </Form.Group>
                ))}
              </Form.Row>
            )}
          </Col>
        </Form.Row>
      </Form>
    );
  }
}

export default ShowTimeslot;
